export const openInANewBrowser = (location: string) => {
    window.open(location, "_blank");
};

export const numberSort = (a?: number | null, b?: number | null) => {
    if (!a && !b) return 0;

    // nulls first
    if (!a) return -1;
    if (!b) return 1;

    if (a < b) return -1;
    if (a > b) return 1;

    return 0;
};

export const evalPath = (path: string, obj: any): any => {
    if (!obj) {
        return null;
    }

    const idx = path.indexOf('.');

    if (idx > -1) {
        const propertyName = path.substring(0, idx);

        if (!obj.hasOwnProperty(propertyName)) {
            console.warn("property not found - " + propertyName);
            return propertyName + " not found";
        }

        return (evalPath(path.substring(idx + 1), obj[propertyName]));
    }

    if (!obj.hasOwnProperty(path)) {
        console.warn("property not found - " + path);
    }

    return obj[path];
};

export const stringSort = (a: string, b: string, ignoreCase: boolean = false) => {
    if (!a && !b) return 0;

    // nulls first
    if (!a) return -1;
    if (!b) return 1;

    const aVal = ignoreCase ? a.toLowerCase() : a;
    const bVal = ignoreCase ? b.toLowerCase() : b;

    if (aVal < bVal) return -1;
    if (aVal > bVal) return 1;

    return 0;
};

export const dateSort = (a?: Date | null, b?: Date | null) => {
    if (!a && !b) return 0;

    // nulls first
    if (!a) return -1;
    if (!b) return 1;

    if (a < b) return -1;
    if (a > b) return 1;

    return 0;
};

